import axios from 'axios';
import { AiReportDataset, AiReportDatasetColumn, AiReportDatasetRow } from '../models/AiReportDataset';

const API_URL = process.env.REACT_APP_SERVER_URL + "/app/ai-report-datasets";

const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('gpcwstoken_kw')}`,
});

export interface AiReportDatasetInput {
    name: string;
    columns: AiReportDatasetColumn[];
    referredColumnKey: string;
}

const aiReportDatasetService = {
    getAll: async (): Promise<AiReportDataset[]> => {
        const response = await axios.get<AiReportDataset[]>(API_URL, { headers: authHeader() });
        return response.data;
    },

    getById: async (id: number): Promise<AiReportDataset> => {
        const response = await axios.get<AiReportDataset>(`${API_URL}/${id}`, { headers: authHeader() });
        return response.data;
    },

    create: async (data: AiReportDatasetInput): Promise<AiReportDataset> => {
        const response = await axios.post<AiReportDataset>(`${API_URL}/add`, data, { headers: authHeader() });
        return response.data;
    },

    update: async (id: number, data: AiReportDatasetInput): Promise<AiReportDataset> => {
        const response = await axios.put<AiReportDataset>(`${API_URL}/update/${id}`, data, { headers: authHeader() });
        return response.data;
    },

    remove: async (id: number): Promise<void> => {
        await axios.delete(`${API_URL}/delete/${id}`, { headers: authHeader() });
    },

    addRow: async (datasetId: number, rowData: Record<string, string>): Promise<AiReportDatasetRow> => {
        const response = await axios.post<AiReportDatasetRow>(`${API_URL}/${datasetId}/rows/add`, rowData, { headers: authHeader() });
        return response.data;
    },

    updateRow: async (datasetId: number, rowId: number, rowData: Record<string, string>): Promise<AiReportDatasetRow> => {
        const response = await axios.put<AiReportDatasetRow>(`${API_URL}/${datasetId}/rows/update/${rowId}`, rowData, { headers: authHeader() });
        return response.data;
    },

    removeRow: async (datasetId: number, rowId: number): Promise<void> => {
        await axios.delete(`${API_URL}/${datasetId}/rows/delete/${rowId}`, { headers: authHeader() });
    },

    bulkAddRows: async (datasetId: number, rows: Record<string, string>[]): Promise<{ success: boolean; created: number; updated: number }> => {
        const response = await axios.post(`${API_URL}/${datasetId}/rows/bulk`, { rows }, { headers: authHeader() });
        return response.data;
    },

    bulkImport: async (datasetId: number, file: File): Promise<{ success: boolean; created: number; updated: number; skippedRows: number[]; totalRows: number }> => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axios.post(`${API_URL}/${datasetId}/import`, formData, {
            headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },
};

export default aiReportDatasetService;
